import { Component, OnInit } from '@angular/core';
import { Headers } from '@angular/http';
import { LoginService, CartaoService, MainService } from 'app/resources/services/index';
import { DefineBootboxId } from 'app/resources/classes';

@Component({
  selector: 'app-epwd-reset',
  templateUrl: './epwd-reset.component.html'
})
export class EpwdResetComponent implements OnInit {

  public mainService: MainService;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public epwdIsNull: boolean;
  public epwd: any;
  public processando: boolean;
  public resetEPwdOk: boolean;

  constructor(mainService: MainService) {
    this.mainService = mainService;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.epwd = { codigoSeguranca: '', nova: '', confirmacao: '' };
    this.mainService.http.pathRest().get('cartao/current/epwdIsNull/', true)
      .subscribe(sucesso => {
        this.epwdIsNull = sucesso.json();
      });
  }

  public saveEPwd() {
    this.processando = true;


    const cabecalho: Headers = new Headers();
    cabecalho.append('Authorization', 'Basic ' + this.mainService.sessionService.getAuthBasic());
    cabecalho.append('Content-Type', 'application/json');
    cabecalho.append('X-Auth-CodigoSeguranca', this.epwd.codigoSeguranca);

    this.mainService.http.pathRest().put('cartao/epwd/', JSON.stringify(this.epwd), true, cabecalho)
      .subscribe(sucesso => {
        this.epwdIsNull = false;
        this.processando = false;
        this.saveSuccess();
      }, erro => {
        this.processando = false;
        this.bootboxAlertComId.alerta(erro._body);
      });
  }

  public saveSuccess() {
    this.mainService.cartaoService.revalidar();
    if (this.epwdIsNull) {
      this.mainService.loginService.changeRoute('/cartao/epwd');
    } else if (!this.epwdIsNull) {
      this.mainService.loginService.changeRoute('/home');
    }

    this.bootboxAlertComId.alerta('Informações salvas com sucesso!');
  }

  resetEPwd() {
    this.processando = true;

    this.mainService.http.pathRest().get('cartao/epwd/reset/' + this.mainService.cartaoService.cartao.uuid + '/', true)
      .subscribe(sucesso => {
        this.processando = false;
        this.resetEPwdOk = true;
        this.bootboxAlertComId.alerta('Mensagem enviada com sucesso!' + `<br>` +
          'Pode levar alguns minutos para que você receba de acordo com seu provedor.' + `<br>` +
          'Por favor, verifique sua caixa de email e preencha os dados abaixo.');
      }, erro => {
        this.processando = false;
        this.resetEPwdOk = false;
      });
  };

}



// WEBPACK FOOTER //
// ./src/app/menu-superior/meu-cadastro/epwd-reset/epwd-reset.component.ts